/*****************************
* ブラウザ情報を取得する
*/

exports.isMobile = (function(){ 'use strict'; return isMobile; })();
exports.browser = (function(){ 'use strict'; return browser; })();


var isMobile = checkMobile();
var browser = getBrowser();

/****************************
* モバイル判定
*/
function checkMobile(){
    'use strict';
    var agent = navigator.userAgent;

    if(agent.search(/iPhone/) != -1 || agent.search(/iPad/) != -1 || agent.search(/iPod/) != -1 || agent.search(/Android/) != -1){
        $('body').addClass('isMobile');
        $.isMobile = true;
        return true;
    }else{
        $('body').addClass('isPC');
        $.isMobile = false;
        return false;
    }
}

/****************************
* ブラウザ判別
*/
function getBrowser(){
    'use strict';

    var ua = window.navigator.userAgent.toLowerCase();
    var ver = window.navigator.appVersion.toLowerCase();
    var name = 'unknown';

    if (ua.indexOf("msie") != -1){
        if (ver.indexOf("msie 6.") != -1){
            name = 'ie6';
        }else if (ver.indexOf("msie 7.") != -1){
            name = 'ie7';
        }else if (ver.indexOf("msie 8.") != -1){
            name = 'ie8';
        }else if (ver.indexOf("msie 9.") != -1){
            name = 'ie9';
        }else if (ver.indexOf("msie 10.") != -1){
            name = 'ie10';
        }else{
            name = 'ie';
        }
    }else if(ua.indexOf('trident/7') != -1){
        name = 'ie11';
    }else if (ua.indexOf('chrome') != -1){
        name = 'chrome';
    }else if (ua.indexOf('safari') != -1){
        name = 'safari';
    }else if (ua.indexOf('opera') != -1){
        name = 'opera';
    }else if (ua.indexOf('firefox') != -1){
        name = 'firefox';
    }
    return name;
}





/*****************
 ** WEBPACK FOOTER
 ** /Users/dada/www/_template/.src/js/caracol2.0.0/util/check_user_agent.js
 ** module id = 2
 ** module chunks = 0
 **/